/**
 * @file Modal atom — centered dialog overlay family.
 * @description structured atom: compound parts re-exported from the vendored
 * Gluestack family; this is the only sanctioned import path for app code
 * (RFC §3).
 * @module components/atoms/Modal
 */
export {
  Modal,
  ModalBackdrop,
  ModalContent,
  ModalCloseButton,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "@/components/ui/modal";
